import { useEffect } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc } from "firebase/firestore";
import { getProductsCollection } from "~/integrations/firebase/collections";
import { logError } from "~/shared/services/error-reporting";

export const useProductData = (productId?: string) => {
  const [product, loading, error] = useDocumentData(
    productId ? doc(getProductsCollection(), productId) : undefined,
  );

  useEffect(() => {
    if (error) {
      logError(error, { extra: { productId } });
    }
  }, [error, productId]);

  return { product, loading, error };
};
